import React, {useEffect, useState} from 'react';
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {Controller} from 'react-hook-form';

const RichTextEditor = ({name, control, error = null}) => {
  const [editorLoaded, setEditorLoaded] = useState(false);

  useEffect(() => {
    setEditorLoaded(true);
  }, []);

  return (
    <Controller
      control={control}
      name={name}
      render={({field: {onChange, value, name}}) => (
        <>
          <div className="rich-text-editor">
            {editorLoaded ? (
              <CKEditor
                type=""
                name={name}
                config={{
                  toolbar: [
                    'bold',
                    'italic',
                    '|',
                    'numberedList',
                    'bulletedList',
                    '|',
                    'outdent',
                    'indent',
                    '|',
                    'undo',
                    'redo',
                    '|',
                    'link',
                  ],
                }}
                editor={ClassicEditor}
                data={value}
                onChange={(_, editor) => {
                  const data = editor.getData();
                  onChange(data);
                }}
              />
            ) : (
              <div>Editor loading</div>
            )}
          </div>
          {error && <div className="text-error text-sm pt-1">{error}</div>}
        </>
      )}
    />
  );
};

export default RichTextEditor;
